<template>
  <div>
    <RandomStyle
      v-if="mode === 'random'"
      ref="RandomTextArea"
      :random-word-data="RandomData"
    ></RandomStyle>
    <SentenceStyle
      v-else
      ref="SentenceTextArea"
      :list-word-data="sentenceData"
    ></SentenceStyle>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
    />
    <successDialog
      v-if="showDialog"
      @clickConfirm="clickConfirm"
      @clickClose="clickClose"
      :is-confirm-dialog="true"
      :dialog-title="'Congratulations'"
    >
      <div slot="dialogDetail" class="dialogDetail">
        <p>任务成功完成</p>
      </div>
    </successDialog>
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import SentenceStyle from "../../StyleText/SentenceStyle";
import RandomStyle from "../../StyleText/RandomStyle";
import successDialog from "../../components/miniDialog";
// import ShotStyle from "../../StyleText/ShotStyle";
export default {
  name: "ShortcutsStep",
  components: {
    SentenceStyle,
    RandomStyle,
    successDialog,
    // ShotStyle,
    SimpleKeyboard,
  },
  data() {
    return {
      showDialog: true,
      mode: "randuom",
      input: "",
      RandomData: "Javscript",
      sentenceData:
        "Hello World &Python C++ Words Excel PPT Javascript Letter Fuck Shift Ctrl",
    };
  },
  mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);
      if (this.mode === "random") {
        // this.$refs.ShotTextArea.handlerWord(btn);
        this.$refs.RandomTextArea.handlerWord(btn);
      } else {
        var ch = this.$refs.SentenceTextArea.nextWord();
        if (btn === false) {
          return true;
        }
        this.$refs.SentenceTextArea.handlerWord(btn);
        return ch === btn;
      }
    };
  },
  methods: {
    onChange(input) {
      this.input = input;
      console.log(input, "input");
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
    clickConfirm() {
      this.index = 0;
      let next = this.$route.params.step * 1 + 1;
      this.$router.push({ path: `${next}` });
      this.showDialog = false;
    },
    clickClose() {
      console.log("关闭暂缓");
      this.showDialog = false;
    },
  },
};
</script>

<style lang="less" scoped></style>
